import isEmpty from "./isEmpty";
export default function isPassword(value: string): boolean {
  return !isEmpty(value);
}
